import React from 'react';
import { FormControl } from 'react-bootstrap';

const StaticText = ({ value }) => {
  return (
    <FormControl.Static className="green bold">{value}</FormControl.Static>
  );
};

export default StaticText;



// WEBPACK FOOTER //
// ./src/components/form/StaticText.js